export default __webpack_public_path__ + "/image/GitHub-64px_b039b2d.png";